import React, { useState, useRef, useEffect } from "react";
import "./App.css";

import { ToastProvider, useToast } from "./component/ToaserNew";
import Footer from "./component/Footer";
import CartView from "./component/CartView";
import { DropDownButton } from "./component/dropdownv2";
import PopupProduct from "./component/PopupProduct";
import MegaMenu from "./component/Mega";
import StoreHelmet from "./component/StoreHelment";
import CategoryView from "./component/CategoryItem";
import { PlaceholderCard, LandingHeader } from "./component";
import { axios, productStats } from "./Network";
import CardV2 from "./component/CardV2";
import toast, { Toaster } from "react-hot-toast";
import ContentLoader from "react-content-loader";
import moment from "moment";
import "moment-timezone";
import { setHours, setMinutes } from "date-fns";
import ReactGA from "react-ga";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";

import { Link } from "react-router-dom";
import TabV3 from "./component/TabV3";
import { useParams, useLocation } from "react-router-dom";

const App = () => {
  const { showToast } = useToast();

  var primaryProduct = process.env.REACT_APP_DEFAULT_PRIMARY_PRODUCT;
  const cartViewRef = useRef();
  const [product, setProducts] = useState([]);
  const [mainQueryTo, setMain] = useState(null);
  const [mainID, setIdentifier] = useState(null);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const mainQuery = query.get("query"); // "subb"
  const identifer = query.get("id"); // "3232132"
  const categoryTitle = query.get("title"); // "3232132"
  const [cart, setCartItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState("");
  const [exploringItems, setStillExploring] = useState([]);
  useEffect(() => {
    console.log("mainQuery", mainQuery, mainQuery != null);
    setMain(mainQuery);
    setActiveCategory(primaryProduct);
    setIdentifier(identifer);
    reloadItem(primaryProduct, 4, true);
    if (mainQuery != null) {
      fetchStoreProduct(mainQuery, identifer).then((results) => {
        setProducts(results.data.results);
      });
    }
    let existingCart = localStorage.getItem("UserCart");
    if (existingCart !== null) {
      let jsonCart = JSON.parse(existingCart);
      setCartItems(jsonCart);
    }

    try {
      const stored = localStorage.getItem("categories");
      if (stored) {
        setCategories(JSON.parse(stored));
      }
    } catch (error) {
      console.error("Failed to load categories:", error);
    }
  }, []);

  async function fetchStoreProduct(query, id) {
    try {
      var defaultDate = new Date();
      var convertedUserDate = moment(defaultDate).format("yyyy-mm-dd");
      let userSeletedDate = localStorage.getItem("userQ");
      var date = JSON.parse(userSeletedDate);
      // setSelectedDate(date);
      const data = {
        queryData: { [query]: id },
      };
      const response = await axios.post("/detailsV2/Product", data);
      return response;
    } catch (error) {
      toast("Please try again later..");
    }
  }

  function addRemoveItem(e, status) {
    try {
      if (status) {
        // toast.success(`${e.title.substring(0, 4)}... has been added `);
        showToast({
          title: `${e.title.substring(0, 4)}`,
          description: "Has been added to cart.",
        });
        setCartItems((prevArray) => [...prevArray, e]);
        let existingCart = cart;
        if (cart.length) {
          let existingCart = localStorage.getItem("UserCart");
          let jsonCart = JSON.parse(existingCart);
          jsonCart.push(e);
          localStorage.setItem("UserCart", JSON.stringify(jsonCart));
          localStorage.setItem("UserCart_Cache", JSON.stringify(jsonCart));
        } else {
          let initialCart = [];
          initialCart.push(e);
          localStorage.setItem("UserCart", JSON.stringify(initialCart));
          localStorage.setItem("UserCart_Cache", JSON.stringify(initialCart));
        }
      } else {
        let filteredCart = cart.filter((item) => item._id !== e._id);
        setCartItems(filteredCart);

        localStorage.setItem("UserCart", JSON.stringify(filteredCart));
      }
    } catch (error) {
      console.log("errorr", error);
    }
  }
  const openCartView = () => {
    cartViewRef.current.openModal();
  };
  const handleOpenCartView = React.useCallback(() => {
    openCartView();
  }, []);

  function renderItem(source) {
    var data = [];
    var sortedProduct = source.sort(
      (a, b) => parseInt(a.price) - parseInt(b.price),
    );
    var sourceItem = sortedProduct;
    var activePromo = 2; //storeDetails.storeOptions.activeCategoryPromo[0].category;
    if (sourceItem.length) {
      sourceItem.map((item) => {
        var isAdded =
          cart.filter((data) => data._id === item._id).length === 0
            ? false
            : true;
        data.push(
          <>
            <CardV2
              activePromo={activePromo}
              type="Display"
              // view={(e) => setCurrentView(e)}
              // update={didUpdate}
              existing={isAdded}
              item={item}
              didAdd={(item) => addRemoveItem(item, true)}
              // didRemove={(item) => addRemoveItem(item, false)}
            />
          </>,
        );
      });
      return data;
    } else {
      for (var i = 0; i < 4; i++) {
        data.push(<PlaceholderCard />);
      }
      return data;
    }
  }

  const reloadItem = (item) => {
    // fetchStoreProduct(mainQuery, identifer).then((results) => {
    //   setProducts(results.data.results);
    // });
    console.log(item);
    setActiveCategory(item);
    const service = async (item) => {
      try {
        const data = {
          id: item,
          queryType: "filter",
          storeOwner: "5ff00ddaeb2f5d0940dfa186",
          isAPI: true,
          showLimit: true,
          number: 4,
          deliveryDate: moment(Date()).format("YYYY-MM-DD"),
        };
        const response = await axios.post("/productV2/Product", data);
        return response;
      } catch (error) {}
    };
    service(item).then((results) => {
      setStillExploring(results.data.results);
    });
  };
  const renderCategoryDisplayName = () => {
    try {
      return categories.length
        ? categories.filter((data) => data.title === activeCategory)[0]
            .displayName
        : null;
    } catch (error) {
      return <>....</>;
    }
  };
  return (
    <>
      <ToastProvider>
        <a href="/">
          <button className="ml-4 mt-6 flex items-center space-x-2 text-black font-semibold hover:opacity-80">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
            <span>Back to Home</span>
          </button>
        </a>
        <div>
          <div className="bg-white px-6 py-6">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-xl font-medium text-gray-900">
                  Exploring for,
                </h1>
                <h2 className="text-2xl font-bold text-gray-900">
                  {categoryTitle} Collection
                </h2>
              </div>
              <div className="p-2">
                <a href="/cart">
                  {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <circle cx="9" cy="21" r="1" />
                  <circle cx="20" cy="21" r="1" />
                  <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
                </svg>*/}
                </a>
              </div>
            </div>
          </div>

          {/* Promotional Banner Section */}
          <div className="px-2 py-4">
            <div className="bg-white  border border-gray-100 rounded-2xl p-6 relative overflow-hidden">
              <div className="flex justify-between items-center">
                <div className="flex-1">
                  <h3 className="text-sm font-medium text-green-800 mb-1"></h3>
                  <h2 className="text-xl font-bold text-green-900 mb-2">
                    Elena
                  </h2>
                  <p className="text-sm text-green-800 mb-4 max-w-xs">
                    Blooms: Pink Roses, Gerberas, Carnations, and Lisianthus
                    with Eucalyptus and Misty Blue Fillers
                  </p>
                  <Link to={"Details/66b606fc2a95e4da69e34b1a"}>
                    <button className="bg-gray-900 text-white px-4 py-2 rounded-full text-sm font-medium">
                      View now
                    </button>
                  </Link>
                </div>
                <div className="flex-shrink-0 ml-4">
                  <img
                    src="https://localflowershop.sgp1.digitaloceanspaces.com/product/1723205356582-17.png"
                    alt="Murad Product"
                    className="w-64 h-64 object-cover rounded-lg"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="max-w-screen-xl px-4 py-8 group group-hover:text-red-200 mx-auto">
          {true === null ? null : (
            <span className="flex items-center ">
              {/* <h5 class=" text-sm  text-black/90">Available items for <span className="text-blue-400 ml-2"> {moment(selectedDate.date).format("MMMM DD YYYY").toString()}</span></h5>
   <img src="https://img.icons8.com/material-outlined/344/calendar--v1.png" className="h-4 w-4 mx-2 " /> */}
            </span>
          )}
          <div>
            <span class="inline-block w-12 h-1 bg-red-200"></span>
            <h2 class="mt-1 text-2xl font-extrabold  tracking-wide uppercase lg:text-3xl">
              {/* {searchedItem}*/}
            </h2>
            <h5 class=" text-sm  text-gray-500">
              {/* {searchedResults.length} items found*/}
            </h5>
          </div>
          <div class="grid grid-cols-2 mt-8 lg:grid-cols-4 gap-x-4 gap-y-8">
            {true != null ? renderItem(product) : null}
          </div>
        </div>
        <div className="relative">
          <h3 className={`ml-6 text-2xl font-bold  text-gray-900 mb-3`}>
            Still Exploring?
          </h3>
          <CartView
            ref={cartViewRef}
            storeDetails={null}
            removeItem={(item) => addRemoveItem(item, false)}
            items={cart}
          />
          {categories ? (
            <div className="sticky bottom-0 right-0 w-full bg-white">
              <div className="overflow-x-auto scrollbar-hide">
                <TabV3
                  active={primaryProduct}
                  items={categories}
                  reload={(selected) => reloadItem(selected, 4, true)}
                />
              </div>{" "}
            </div>
          ) : null}

          <div class="max-w-screen-xl px-4 py-8 group group-hover:text-red-200 mx-auto">
            {true === null ? null : (
              <span className="flex items-center ">
                {/* <h5 class=" text-sm  text-black/90">Available items for <span className="text-blue-400 ml-2"> {moment(selectedDate.date).format("MMMM DD YYYY").toString()}</span></h5>
   <img src="https://img.icons8.com/material-outlined/344/calendar--v1.png" className="h-4 w-4 mx-2 " /> */}
              </span>
            )}
            <div>
              <span class="inline-block w-12 h-1 bg-red-200"></span>
              <h2 class="mt-1 text-2xl font-extrabold  tracking-wide uppercase lg:text-3xl">
                {/* {searchedItem}*/}
              </h2>
              <h5 class=" text-sm  text-gray-500">
                {/* {searchedResults.length} items found*/}
              </h5>
            </div>
            <div class="grid grid-cols-2 mt-8 lg:grid-cols-4 gap-x-4 gap-y-8">
              {true != null ? renderItem(exploringItems) : null}
            </div>
            <a
              target="_blank"
              href={`/Explore/Category?query=type&id=${activeCategory}&title=${renderCategoryDisplayName()}`}
            >
              {/* <button
            // onClick={() =>
            //   router.push(
            //
            //   )
            // }
            className="text-sm text-gray-500"
          >
            See all
          </button>*/}

              <button
                style={{ backgroundColor: "black" }}
                className=" mt-20 text-white px-4  text-white py-2 rounded-full text-sm font-medium"
              >
                See all
              </button>
            </a>
          </div>
        </div>

        <button
          onClick={() => cartViewRef.current.openModal()}
          class="fixed bottom-6 right-6 bg-black text-white p-4 rounded-full shadow-lg hover:bg-gray-700 transition"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <circle cx="9" cy="21" r="1" />
            <circle cx="20" cy="21" r="1" />
            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
          </svg>
        </button>
        <Toaster />
      </ToastProvider>
    </>
  );
};

export default App;
